import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ImportExportStateClass } from './interfaces/importExportStateClass'
const initialState: ImportExportStateClass = {
    isLoading: false,
    status: 'idle',
    ImportExportList: [],
    DataSourceSchema: [],
    selectedRecord: {},
    isReload : false,
    fileName : "",
    isImportExport: false

}
interface IThunkApi {
    state: {
        importExport: ImportExportStateClass;
    }
}
export const getDataTableForExportAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'importExport/GetDataTableForExport',
        async (arg, thunkApi) => {
            const {TableName} = arg;
            const {AccountEmployeeId} = arg;
            const {AccountWorkTypeId} = arg;
            const {AccountProjectId} = arg;
            const {StartDate} = arg;
            const {EndDate} = arg;
            const {WhereClause}= arg;
          
            const defaultparameters = {TableName:TableName,AccountEmployeeId:AccountEmployeeId,AccountWorkTypeId:AccountWorkTypeId,AccountProjectId:AccountProjectId, StartDate:StartDate,EndDate:EndDate}
            const array = {defaultparameters:defaultparameters,WhereClause:WhereClause}
            //const response = await fetchAPI('api/v2/ImportExport/GetDataTableForExport/'+ TableName + '/' + AccountEmployeeId + '/' + AccountProjectId + '/' + AccountWorkTypeId + '/' + StartDate  + '/' + EndDate + '/' + nWhereClause, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const response = await fetchAPI('api/v2/ImportExport/GetDataTableForExport', 'POST', array,
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const getDataSourceSchemaAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'importExport/GetTableSchema',
        async (arg, thunkApi) => {
           
            const response = await fetchAPI('api/v2/ImportExport/GetTableSchema/'+ arg , 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const ImportCSVAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'importExport/AddImportCSV',
        async (arg, thunkApi) => {        
            const { data, dbTable, Table, IsUpdate} = arg;
            const response = await fetchAPI('api/v2/ImportExport/AddImportCSV/' + dbTable + '/' + Table + '/' + IsUpdate, 'POST', data , true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

    export const checkImportValidationForDuplicateDataAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'importExport/CheckImportValidationForDuplicateData',
        async (arg, thunkApi) => {
            const { data,TableName } = arg;
            const response = await fetchAPI('api/v2/ImportExport/CheckImportValidationForDuplicateData/'+ TableName, 'POST', data, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    ) 
  
export const importExportSlice = createSlice({
    name: 'importExport',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setisImportExport: (state, action: PayloadAction<any>) => {
            state.isImportExport = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getDataTableForExportAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getDataTableForExportAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = false;
                state.selectedRecord = payload;
                state.ImportExportList = payload.data;
                state.fileName = payload.fileName      
            })
            .addCase(getDataTableForExportAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getDataSourceSchemaAsync.pending, (state) => {
                state.status = 'loading';
               // state.isLoading = true;
            })
            .addCase(getDataSourceSchemaAsync.fulfilled, (state, { payload }) => {
           
                state.status = 'idle';
               // state.isLoading = false;
                state.DataSourceSchema = payload.Data;
                state.selectedRecord = payload.Data;
                state.isReload = false;
            })
            .addCase(getDataSourceSchemaAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(checkImportValidationForDuplicateDataAsync.rejected, (state) => {
                state.status = 'failed';
                //state.isLoading = false;
            })
            .addCase(checkImportValidationForDuplicateDataAsync.pending, (state) => {
                state.status = 'loading';
                //state.isLoading = true;
            })
            .addCase(checkImportValidationForDuplicateDataAsync.fulfilled, (state, { payload }) => {             
                state.status = 'idle';
               // state.isLoading = false;
                state.selectedRecord = payload.Data;
                state.isReload = false;
            })
            
          
           
            .addCase(ImportCSVAsync.pending, (state) => {
                state.status = 'loading';
                //state.isLoading = true;
            })
            .addCase(ImportCSVAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //state.isReload = true;
                //state.isLoading = true;
            })
            .addCase(ImportCSVAsync.rejected, (state) => {
                state.status = 'failed';
                //state.isLoading = true;
            })
    }
})
export const {
    resetSelectedRecordObjectInState,setIsLoading,setisImportExport
} = importExportSlice.actions
export const importExportStateClass = (state: RootState) => state.importExport
 export default importExportSlice.reducer